import { render, staticRenderFns } from "./trill-service-item.vue?vue&type=template&id=739c1628&scoped=true&"
import script from "./trill-service-item.vue?vue&type=script&lang=ts&"
export * from "./trill-service-item.vue?vue&type=script&lang=ts&"
import style0 from "./trill-service-item.vue?vue&type=style&index=0&id=739c1628&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c1628",
  null
  
)

export default component.exports